/** @format */

export const OFFSET_UP = 6;

export const OFFSET_DOWN = -15;

export const OFFSET_CENTER = -4;

export const DIGIT_WIDTH = 6.8;
